import axios from 'axios'

/**
 * その契約企業で使ってよいログイン方法の設定。
 *
 * ## なぜ画面から触れる必要があるのか
 *
 * フラグは最初から表（`t_account_auth_policy`）にあったのに、**読み書きする
 * 口が無かった。**パスキーを1社ぶん開けるだけで、こちらが本番のDBへ
 * SQLを流していた。**他社へ売る製品でそれは続かない。**
 *
 * ## なぜ PUT で全部送るのか
 *
 * 部分更新にしない。送らなかった項目はサーバが変えない、という約束を
 * 作ると、**画面が持っている値とサーバの値が食い違ったときに誰も
 * 気づけない。**画面に出ている6つをそのまま送り、サーバはその通りに
 * 置き換える。ずれていれば、次に開いたとき画面のほうが直る。
 *
 * だから画面で変えられない項目（いまは Microsoft）も、**読んだ値を
 * そのまま送り返す。**落とすと消える。
 *
 * ## 判断はここでしない
 *
 * 形（ドメインの綴り、ログイン方法が1つも無い、など）は画面が見るが、
 * **通してよいかを決めるのはサーバ**。画面の検査は「押す前に気づける」
 * ためのもので、守りではない。画面を通さずに投げられたら意味が無い。
 */

const origin = process.env.VUE_APP_API_ORIGIN

const responseData = response => response.data

export default {
  get () {
    return axios.get(origin + '/setting/auth-policy').then(responseData)
  },
  update (payload) {
    return axios.put(origin + '/setting/auth-policy', payload).then(responseData)
  }
}
